import { tx } from "@/i18n/tx";
import axios from "axios";
import i18n from "@/i18n";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// httpOnly cookie is set by backend on login/register and sent automatically
// because of withCredentials. No token in localStorage = no XSS risk.
export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Global 402 interceptor: when server refuses because trial expired,
// redirect user to the subscription page.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const d = err?.response?.data?.detail;
    if (err?.response?.status === 401 && d?.code === "account_disabled" && window.location.pathname.startsWith("/app")) {
      window.location.href = "/login?disabled=1";
    }
    if (err?.response?.status === 402) {
      const path = window.location.pathname;
      if (!path.startsWith("/app/plus") && !path.startsWith("/billing")) {
        window.location.href = "/app/plus?paywall=1";
      }
    }
    return Promise.reject(err);
  }
);

export function formatApiErrorDetail(detail) {
  if (detail == null) return tx("ui_api.k557bca");
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && detail.code === "account_disabled") return i18n.t("account.disabled");
  if (detail && typeof detail.msg === "string") return detail.msg;
  if (detail && typeof detail.message === "string") return detail.message;
  return String(detail);
}

export const fmtCHF = (n) =>
  i18n.language?.startsWith("de")
    ? `CHF ${Number(n || 0).toLocaleString("de-CH", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/[’\u2019]/g, "'")}`
    : new Intl.NumberFormat("fr-CH", { style: "currency", currency: "CHF" }).format(n || 0);

export const fmtDate = (s) => {
  if (!s) return "";
  try {
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return s;
    const dd = String(d.getDate()).padStart(2, "0");
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const yyyy = d.getFullYear();
    return `${dd}-${mm}-${yyyy}`;
  } catch {
    return s;
  }
};

export const downloadFile = async (url, filename) => {
  const r = await fetch(url, { credentials: "include" });
  if (!r.ok) throw new Error("download failed");
  const blob = await r.blob();
  const href = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = href; a.download = filename; a.click();
  URL.revokeObjectURL(href);
};
